import { supabase } from './supabase';

export interface NotificationPreferences {
  id: string;
  user_id: string;
  weekly_digest_enabled: boolean;
  digest_day_of_week: number;
  digest_hour_utc: number;
  created_at: string;
  updated_at: string;
}

export async function getNotificationPreferences(): Promise<NotificationPreferences | null> {
  const { data: { user } } = await supabase.auth.getUser();
  
  if (!user) {
    return null;
  }

  const { data, error } = await supabase
    .rpc('get_or_create_notification_preferences', { p_user_id: user.id });

  if (error) {
    console.error('Error fetching notification preferences:', error);
    return null;
  }

  return data as NotificationPreferences;
}

export async function updateNotificationPreferences(
  updates: Partial<Pick<NotificationPreferences, 'weekly_digest_enabled' | 'digest_day_of_week' | 'digest_hour_utc'>>
): Promise<NotificationPreferences | null> {
  const { data: { user } } = await supabase.auth.getUser();
  
  if (!user) {
    return null;
  }

  const { data, error } = await supabase
    .from('user_notification_preferences')
    .update(updates)
    .eq('user_id', user.id)
    .select()
    .single();

  if (error) {
    console.error('Error updating notification preferences:', error);
    return null;
  }

  return data as NotificationPreferences;
}

export async function toggleWeeklyDigest(enabled: boolean): Promise<boolean> {
  const result = await updateNotificationPreferences({ weekly_digest_enabled: enabled });
  return result !== null;
}

export const DAYS_OF_WEEK = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

export const HOURS_UTC = Array.from({ length: 24 }, (_, i) => ({
  value: i,
  label: `${i.toString().padStart(2, '0')}:00 UTC`,
}));
